import { Box, Button, Grid } from "@mui/material";
import LoanTable from "../../components/Fleet/LoanTable/LoanTable";
import LoanPopup from "../../components/Fleet/LoanPopup/LoanPopup";
import ExcelUploadPopup from "../../components/Fleet/ExcelUploadPopup/ExcelUploadPopup";
import { useState } from "react";

const LoanPage = () => {
  const [isOpenLoanBalanceOpen, setIsOpenLoanBalanceOpen] = useState(false);
  const [isLoanOpen, setIsLoanOpen] = useState(false);
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <LoanPopup />
              </Grid>
              <Grid item>
                {/* <Button
                  variant="contained"
                  component="label"
                  onClick={() => setIsLoanOpen(true)}
                >
                  Upload Loans
                </Button> */}
                <ExcelUploadPopup
                  open={isLoanOpen}
                  onClose={() => setIsLoanOpen(false)}
                  fileType="loan"
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  component="label"
                  onClick={() => setIsOpenLoanBalanceOpen(true)}
                >
                  Upload Loan Balances
                </Button>
                <ExcelUploadPopup
                  open={isOpenLoanBalanceOpen}
                  onClose={() => setIsOpenLoanBalanceOpen(false)}
                  fileType="loanbalance"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <LoanTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoanPage;
